import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.uploadVideo;

export const currentPageSelector = createSelector(
  (state) => baseSelector(state).currentPage,
  (currentPage) => currentPage
);

export const uploadVideoModalStateSelector = createSelector(
  (state) => baseSelector(state).uploadVideoModalState,
  (uploadVideoModalState) => uploadVideoModalState
);

export const videoSearchInputSelector = createSelector(
  (state) => baseSelector(state).videoSearchInput,
  (videoSearchInput) => videoSearchInput
);

export const videoUploadSuccessSelector = createSelector(
  (state) => baseSelector(state).videoUploadSuccess,
  (videoUploadSuccess) => videoUploadSuccess
);
